import ANYTIME from '../constants/timeDropdownConstants';
import { END_TIME } from '../constants/dateConstants';

export const isValidTime = ({
  startDate, endDate, startTime, value, stateKey,
}) => {
  if (startDate && endDate && value && startDate === endDate
    && value !== ANYTIME) {
    if (startTime && stateKey === END_TIME && startTime !== ANYTIME) {
      return value >= startTime;
    }
  }
  return true;
};
export const getTimeLabels = (isEnabledNewTimeLabel) => ({
  timeAriaLabelForDeparture: isEnabledNewTimeLabel ? 'aria.departure_time.new' : 'aria.departure_time',
  timeAriaLabelForArrival: isEnabledNewTimeLabel ? 'aria.arrival_time.new' : 'aria.arrival_time',
});
